// https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
/**
 * @deprecated Use isValidJsDate from 'async-timing' instead.
 * This function will be removed in a future version.
 */
export default function isValidJsDate(maybeDate: any): boolean {
  return maybeDate instanceof Date && !Number.isNaN(maybeDate);
}
